module.exports = __webpack_public_path__ + "static/img/warning.0775d32.svg";